import {
  getCategoryByContextIdUrl,
  getCategoryByIdUrl,
  getCategoryByTypeUrl,
  getCategoryUrl,
  getOutcomesByCategoryUrl,
  getUncategorizedOutcomesByContextUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class OutcomeCategoryService {
  static getCategories() {
    return getRequest(getCategoryUrl());
  }

  static getCategoryById(categoryId) {
    return getRequest(getCategoryByIdUrl(categoryId));
  }

  static getCategoryByType(loType) {
    return getRequest(getCategoryByTypeUrl(loType));
  }

  static getOutcomesByCategory(categoryId) {
    return getRequest(getOutcomesByCategoryUrl(categoryId));
  }

  static createOutcomeCategory(category) {
    return postRequest(getCategoryUrl(), category);
  }

  static async updateOutcomeCategory(category) {
    let category_id = category.ddl_id ?? category.id;
    return putRequest(getCategoryByIdUrl(category_id), category);
  }

  static deleteOutcomeCategory(categoryId) {
    return deleteRequest(getCategoryByIdUrl(categoryId));
  }

  static getOutcomeCategoriesByContext(contextId, fullOutcomes, signal = null) {
    let params = {};
    if (fullOutcomes) {
      params.fullOutcomes = fullOutcomes;
    }
    return getRequest(
      getCategoryByContextIdUrl(contextId),
      params,
      false,
      signal
    );
  }

  static getUncategorizedOutcomesByContext(contextId, signal = null) {
    return getRequest(
      getUncategorizedOutcomesByContextUrl(contextId),
      {},
      false,
      signal
    );
  }
}
